import { EventEmitter } from "@angular/core";

export const onHeaderLoading = new EventEmitter<boolean>();
